module.exports = __webpack_public_path__ + "bb.fce8ac3e854ddf319fb2.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bb.svg
// module chunks = styles